import styled from 'styled-components';

export const Container = styled.div`
  // header > content spacing
  > * + * {
    margin-top: 1.6rem;
  }
`;
